import(/* webpackMode: "eager" */ "/workspace/src/app/info/layout.jsx");
